<template>
  <div class="q-page-not-found">
    <h3 class="q-page-not-found__header">
      Такой страницы не существует
    </h3>
    <h1 class="q-page-not-found__error">
      404
    </h1>
    <AButton type="link" @click="back">
      Вернуться туда где всё работало
    </AButton>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

function back() {
  router.back()
}
</script>

<style lang="sass" scoped>
@import './QPageNotFoundView'
</style>
